import { orgStorage } from "@/utils/org-storage";
import storeUtils from "@/stores/utils";

export function filtersPanelStorageKey(scope) {
    return storeUtils.getFiltersPanelStorageKey(scope);
}

export function loadFiltersPanelOpen(scope) {
    const storageKey = filtersPanelStorageKey(scope);
    if (!storageKey || typeof window === "undefined") {
        return false;
    }
    try {
        const raw = orgStorage.getItem(storageKey);
        if (!raw) {
            return false;
        }
        const parsed = JSON.parse(raw);
        return parsed?.open === true;
    } catch {
        return false;
    }
}

export function saveFiltersPanelOpen(scope, open) {
    const storageKey = filtersPanelStorageKey(scope);
    if (!storageKey || typeof window === "undefined") {
        return;
    }
    try {
        orgStorage.setItem(storageKey, JSON.stringify({ open: !!open }));
    } catch {
        // ignore quota errors
    }
}

/** Open the table filters panel so applied route filters are visible in the UI. */
export function revealFiltersPanelForScope(scope) {
    if (!scope) {
        return;
    }
    saveFiltersPanelOpen(scope, true);
}
